<template>
  <div class="flex justify-between items-center w-full cursor-pointer" @click="handleBotClick">
    <div v-if="isRenameMode"
         class="w-2/3"
         @click.stop.prevent
    >
      <input-with-error-message id="bot-editor-name-input"
                                :value.sync="botName"
                                :is-loading="isLoading"
                                @keydown.space.stop
                                @escape="isRenameMode = false"
                                @submit="submitBotName"
      />
    </div>

    <template v-else>{{ bot.name }}</template>

    <div class="flex items-center gap-10">
      <span class="font-normal text-gray-dark">
        {{ channelsText }}
      </span>

      <div @click.prevent.stop class="w-12">
        <side-list-menu v-if="!isRenameMode"
                        :items="menuItems"
                        @rename="isRenameMode = true"
                        @delete="requestDelete"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SideListMenu from '@/components/common/SideListMenu.vue'
import { MENU_ITEMS } from '@/utils/editor.constants'
import InputWithErrorMessage from '@/components/common/InputWithErrorMessage.vue'

export default {
  name: 'SettingsBotsListTitle',

  props: {
    bot: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isRenameMode: false,
      botName: this.bot.name
    }
  },

  components: { InputWithErrorMessage, SideListMenu },

  emits: ['update:bot-name', 'request-delete', 'select-bot'],

  computed: {
    menuItems() {
      return ['111', '222'].includes(this.bot.id) ? [MENU_ITEMS.rename] : [MENU_ITEMS.rename, MENU_ITEMS.delete]
    },

    channelsText() {
      const channelsCount = this.bot.channels?.length
      if (!channelsCount) return 'No channels'
      const channelsText = `${channelsCount} channel`
      return channelsCount === 1 ? channelsText : channelsText + 's'
    }
  },

  methods: {
    handleBotClick() {
      this.$emit('select-bot', this.bot)
    },

    submitBotName(name) {
      this.$emit('update:bot-name', { ...this.bot, name })
      this.isRenameMode = false
    },

    requestDelete() {
      this.$emit('request-delete', this.bot)
    }
  }
}
</script>
